import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Steps, Popover } from "antd";
import TextInput from "../../components/input/TextInput";
import "./Styles.css";
import { EMAIL_REGX } from "../../config/variables";
import { useDispatch } from "react-redux";
import { AuthAction, UserAction } from "../../store/actions";
import { formatToNumber } from "../../config/utils";
import RMX from "../../assets/images/b-RMX-1.png";
import { useSelector } from "react-redux";
import LoaderGif from "../../assets/images/ie_loader.gif";

const Profile = ({ count, onChangeStep, user, datalog }) => {

  const compId = datalog[1]?.logistics_partner?.id
  const businessName = datalog[1]?.logistics_partner?.business_name
  console.log("signinData", compId, businessName);

  const dispatch = useDispatch();
  const zipcodeErr = useSelector((state) => state.UserReducer.zipcodeError);
  const isLoading = useSelector((state) => state.UserReducer.iszipCodeLoading);
  const loader = useSelector((state) => state.AuthReducer.loader);
  const busineesDataLoader = useSelector((state) => state.UserReducer.isLoading);
  console.log("businees Loader", busineesDataLoader);
  // const [localData, setLocalData] = useState(JSON.parse(localStorage.getItem('logistics_Auth')))
  // if (localData) {
  //   var businessName = localData[1]?.logistics_partner?.business_name
  // }

  const [businessInfo, setBusinessInfo] = useState({
    address: "",
    business_name: "",
    email: "",
    employee_id_number: "",
    phone: "",
    zipcode: "",
    no_of_vehicles: "",
    no_of_drivers: "",
  });
  const [errors, setErrors] = useState({
    addressError: "",
    business_nameError: "",
    emailError: "",
    employee_id_numberError: "",
    phoneError: "",
    zipcodeError: "",
    no_of_driversError: "",
    no_of_vehiclesError: "",
  });
  useEffect(() => {
    setErrors({ ...errors, zipcodeError: zipcodeErr });
  }, [zipcodeErr]);
  const { Step } = Steps;
  const customDot = (dot, { status, index }) => (
    // <></>
    <Popover
      overlayClassName="onhide-popover"
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );
  const onChangeHandle = (e) => {
    setBusinessInfo({
      ...businessInfo,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [`${e.target.name}Error`]: "",
    });
  };
  const onSubmit = () => {
    const {
      address,
      business_name,
      email,
      employee_id_number,
      phone,
      zipcode,
      no_of_drivers,
      no_of_vehicles,
    } = businessInfo;
    let addressError = "";
    let business_nameError = "";
    let emailError = "";
    let employee_id_numberError = "";
    let phoneError = "";
    let zipcodeError = "";
    let no_of_driversError = "";
    let no_of_vehiclesError = "";
    if (
      !address.trim().length ||
      !business_name.trim().length ||
      !email.trim().length ||
      !employee_id_number.trim().length ||
      !phone.toString().trim().length ||
      phone.toString().trim().length < 10 ||
      !no_of_drivers.trim().length ||
      !no_of_vehicles.trim().length
    ) {
      if (!business_name.trim().length) {
        business_nameError = "Business Name is required.";
        setErrors({
          ...errors,
          business_nameError,
        });
      }
      if (!EMAIL_REGX.test(businessInfo.email)) {
        emailError = "Email is required.";
        setErrors({
          ...errors,
          business_nameError,
          emailError,
        });
      }
      if (!address.trim().length) {
        addressError = "Address is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
        });
      }
      if (!employee_id_number.trim().length) {
        employee_id_numberError = "Employe ID is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
          employee_id_numberError,
        });
      }
      if (
        !phone.toString().trim().length ||
        phone.toString().trim().length < 10
      ) {
        phoneError = "Phone is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
          employee_id_numberError,
          phoneError,
        });
      }

      if (!no_of_drivers?.toString()?.trim().length) {
        no_of_driversError = "No. of Drivers is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
          employee_id_numberError,
          phoneError,
          zipcodeError,
          no_of_driversError,
        });
      }

      if (!no_of_vehicles?.toString()?.trim().length) {
        no_of_vehiclesError = "No. of Vehical is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
          employee_id_numberError,
          phoneError,
          zipcodeError,
          no_of_driversError,
          no_of_vehiclesError,
        });
      }
      return;
    }
    if (businessName == "null") {
      dispatch(UserAction.updateBusinessInfoReq({ businessInfo, compId }, () => {
        onChangeStep()
      }))
    }
  };
  const {
    business_nameError,
    addressError,
    emailError,
    employee_id_numberError,
    phoneError,
    zipcodeError,
    no_of_vehiclesError,
    no_of_driversError,
  } = errors;
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} xl={24} lg={24}>
        <Card
          style={{
            boxShadow: 'boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px',
          }}
        >
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              style={{
                padding: "15px",
                justifyContent: "start",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <img
                src={RMX}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  backgroundRepeat: "no-repeat",
                  top: "-20px",
                  paddingLeft: "50px",
                }}
              />
            </Col>
          </Row>
          <Steps current={count} progressDot={customDot}>
            {/* <Step title="Register" /> */}
            <Step title="Create Profile" />
            <Step title="Add Location" />
            <Step title="Personlize" />
            <Step title="Subscription" />
          </Steps>
          <div
            style={{
              width: "91.5%",
              margin: "auto",
              // boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
              border: "solid #eaeaea 1px",
              padding: "1rem",
              marginTop: "20px",
            }}
          >
            <Col className="login-card">
              <h2 className="text-left">Business Information</h2>
            </Col>
            <Row justify="center">
              <Col
                xs={24}
                sm={24}
                md={24}
                xl={12}
                lg={12}
                className="cardpadding"
              >
                <Row>
                  <Col span={24}>
                    <TextInput
                      label={"Registered Business Name"}
                      name="business_name"
                      required
                      onChange={onChangeHandle}
                      value={businessInfo.business_name}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {business_nameError && business_nameError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Email Address "}
                      required
                      name={"email"}
                      onChange={onChangeHandle}
                      value={businessInfo.email}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {emailError && emailError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Address "}
                      required
                      name={"address"}
                      onChange={onChangeHandle}
                      value={businessInfo.address}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {addressError && addressError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Number Of Drivers "}
                      required
                      name={"no_of_drivers"}
                      onChange={onChangeHandle}
                      value={businessInfo.no_of_drivers}
                      type={"number"}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {no_of_driversError && no_of_driversError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>

              <Col
                xs={24}
                sm={24}
                md={24}
                xl={12}
                lg={12}
                className="cardpadding "
              >
                <Row>
                  <Col span={24}>
                    <TextInput
                      label={"Employer Identification Number"}
                      required
                      name={"employee_id_number"}
                      onChange={onChangeHandle}
                      value={businessInfo.employee_id_number}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {employee_id_numberError && employee_id_numberError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Business Phone Number"}
                      required
                      name="phone"
                      onChange={onChangeHandle}
                      value={formatToNumber(businessInfo.phone)}
                      maxLength={15}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {phoneError && phoneError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Zip Code"}
                      required
                      name="zipcode"
                      onChange={onChangeHandle}
                      maxlength={5}
                      value={businessInfo.zipcode}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {isLoading && (
                          <img src={LoaderGif} height={"60"} width={"60"} />
                        )}
                        <span className="danger-color text-right">
                          {zipcodeError && zipcodeError}
                        </span>
                      </Col>
                    </Row>
                  </Col>

                  <Col span={24}>
                    <TextInput
                      label={"Number Of Vehicles "}
                      required
                      name="no_of_vehicles"
                      onChange={onChangeHandle}
                      maxlength={5}
                      value={businessInfo.no_of_vehicles}
                      type={"number"}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {no_of_vehiclesError && no_of_vehiclesError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <Row>
            <Col span={23}>
              <Row
                justify="end"
                align="middle"
                style={{ marginBottom: "20px" }}
              >
                <Col xs={24} sm={24} md={10} lg={8} xl={4}>
                  {!busineesDataLoader && (
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",

                        marginTop: "20px",
                      }}
                      block
                      onClick={() => onSubmit()}
                    >
                      ADD LOCATION
                    </Button>
                  )}
                  {busineesDataLoader && (
                    <Row justify="end" align="middle">
                      <Col
                        className="text-left"
                        xs={6}
                        sm={6}
                        md={10}
                        lg={8}
                        xl={8}
                      >
                        <img src={LoaderGif} height={"60"} width={"60"} />
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>


        </Card>
      </Col>
    </Row>
  );
};

export default Profile;
